import { useReactFlow } from "@xyflow/react";
import Icon from "./Icon";

interface Props {
  onResetClick?: any;
}

export const ZoomControls = (props: Props) => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        background: "rgb(20 23 38)",
        zIndex: 1000,
        padding: "10px",
        borderRadius: "0px 5px 0px 8px",
        border: "1px solid rgb(10 13 31)",
        borderTop: "none",
        borderRight: "none",
        boxShadow: "-2px 2px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <button onClick={() => zoomIn()} style={buttonStyle}>
        + Zoom In
      </button>
      <button onClick={() => zoomOut()} style={buttonStyle}>
        - Zoom Out
      </button>
      <button
        style={{ ...buttonStyle, background: "#008eff" }}
        onClick={() => {
          props.onResetClick();
          fitView();
        }}
      >
        <Icon
          // fixedWidth={false}
          style={{
            width: "20px",
            height: "18px",
            color: "#ffffff",
          }}
          size={2}
          name="sync"
        />
        Reset View
      </button>
    </div>
  );
};

const buttonStyle = {
  border: "1px solid #ffffff20",
  background: "#ffffff05",
  color: "#fff",
  padding: "6px 10px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
